<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<div class="d-flex">
					<h1 class="h3 mb-0 text-gray-800">
						Pedidos A Pagar
					</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="card">
		                <div class="card-header">
				        	<div class="d-flex justify-content-between container overflow-auto">
					            <div class="text-muted fs-19 mr-2">
					            	<strong>Pedidos</strong>
					            </div>
						    </div>
				        </div>
				        <div class="card-body">
				            <pedido-table 
				            	@show="show" 
				            	:link="this.$url+'/api/adm/pedidos/apagar'">
				            </pedido-table>
				        </div>
				    </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			show(dado_id){
				this.$router.push('/adm/pedidos/show/'+dado_id)
			}
		}
	}
</script>